<template>
  <div class="blog-page">

    <!-- Header -->
    <div class="blog-page__header">
      <div class="blog-page__shell">
        <div class="blog-page__badge">
          <span></span>
          <p>SHC Capital</p>
        </div>
        <h1 class="blog-page__title">{{ $t('blog.news') }}</h1>
        <p class="blog-page__subtitle">{{ $t('blog.discoverNews') }}</p>
      </div>
    </div>

    <div class="blog-page__shell">

      <!-- Search + Filter -->
      <div class="blog-page__toolbar">
        <div class="blog-page__search">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35" stroke-linecap="round"/>
          </svg>
          <input
            v-model="searchQuery"
            type="text"
            :placeholder="$t('blog.search')"
          />
        </div>

        <div class="blog-page__filters">
          <button
            @click="selectedCategory = 'all'"
            :class="['blog-page__filter-btn', selectedCategory === 'all' ? 'blog-page__filter-btn--active' : '']"
          >
            {{ $t('common.all') }}
          </button>
          <button
            v-for="cat in categories"
            :key="cat"
            @click="selectedCategory = cat"
            :class="['blog-page__filter-btn', selectedCategory === cat ? 'blog-page__filter-btn--active' : '']"
          >
            {{ cat }}
          </button>
        </div>
      </div>

      <!-- Grid -->
      <div class="blog-grid">
        <article
          v-for="blog in displayedBlogs"
          :key="blog.id"
          class="blog-card"
          @click="navigateTo(blog)"
        >
          <!-- Thumbnail -->
          <div class="blog-card__thumb">
            <div v-if="blog.bannerClass" class="blog-card__banner" :class="blog.bannerClass">
              <div v-if="blog.bannerIcon || blog.bannerLabel" class="blog-card__banner-inner">
                <div v-if="blog.bannerIcon" class="blog-card__banner-icon">
                  <i :class="blog.bannerIcon"></i>
                </div>
                <span v-if="blog.bannerLabel" class="blog-card__banner-label">{{ blog.bannerLabel }}</span>
                <span v-if="blog.bannerSub" class="blog-card__banner-sub">{{ blog.bannerSub }}</span>
              </div>
            </div>
            <img v-else :src="blog.image" :alt="blog.title" class="blog-card__img" />
            <div class="blog-card__overlay"></div>
            <span class="blog-card__category">{{ blog.category }}</span>
            <span v-if="blog.isNew" class="blog-card__new">{{ $t('blog.new') }}</span>
          </div>

          <!-- Body -->
          <div class="blog-card__body">
            <h2 class="blog-card__title">{{ blog.title }}</h2>
            <p class="blog-card__desc">{{ blog.description }}</p>

            <div class="blog-card__meta">
              <span class="blog-card__meta-item">
                <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"/></svg>
                {{ blog.author }}
              </span>
              <span class="blog-card__meta-item">
                <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/></svg>
                {{ blog.publishDate }}
              </span>
            </div>

            <div class="blog-card__tags">
              <span v-for="tag in blog.tags" :key="tag" class="blog-card__tag">#{{ tag }}</span>
            </div>

            <div class="blog-card__footer">
              <div class="blog-card__stats">
                <span>
                  <svg viewBox="0 0 20 20" fill="currentColor"><path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/><path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd"/></svg>
                  {{ blog.views }}
                </span>
                <span>
                  <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"/></svg>
                  {{ blog.likes }}
                </span>
              </div>
              <span class="blog-card__read-more">{{ $t('blog.readMore') }} →</span>
            </div>
          </div>
        </article>
      </div>

      <!-- Empty state -->
      <div v-if="filteredBlogs.length === 0" class="blog-page__empty">
        <span>📝</span>
        <h3>{{ $t('blog.notFound') }}</h3>
        <p>{{ $t('blog.tryAgain') }}</p>
      </div>

      <!-- Load more -->
      <div v-if="hasMoreBlogs" class="blog-page__load-more">
        <button @click="loadMoreBlogs" class="blog-page__load-btn">
          {{ $t('blog.moreBlog') }}
        </button>
      </div>

    </div>
  </div>
</template>

<style src="./blog.scss" lang="scss"></style>
<script src="./blog.js"></script>
